import SvgLogo from "../../assets/svg/SvgLogo";
export const links = [
    {
        id: 1,
        item:<div>О&nbsp;нас</div>,
        link: 'about-us',
    },
    {
        id: 2,
        item: "Услуги",
        link: 'services',
    },
    {
        id: 3,
        item: <SvgLogo/>,
        link: 'home',
    },
    {
        id: 4,
        item: "Галерея",
        link: 'gallery',
    },
    {
        id: 5,
        item: "Контакты",
        link: 'contacts',
    },
]